import type { FileDocumentContext as Context } from "@kollectivia/shared/schemas/files.js";
import { useTranslation } from "react-i18next";

/** Read-only context from the existing cabinet file contract, never a PDF rewrite. */
export function FileDocumentContext({
  context,
  uploadedAt,
}: {
  context?: Context | null;
  uploadedAt: string;
}) {
  const { t, i18n } = useTranslation();
  if (!context) return null;
  const date = new Date(uploadedAt);
  return (
    <div className="mt-1 space-y-1 break-words text-sm text-slate-600">
      {context.request_title && <p>{context.request_title}</p>}
      {context.template_name && (
        <p>
          {context.template_name}
          {context.version_number
            ? ` · ${t("request_flow.version", { number: context.version_number })}`
            : ""}
        </p>
      )}
      {!Number.isNaN(date.getTime()) && (
        <p>{date.toLocaleString(i18n.language.startsWith("fr") ? "fr-CA" : "en-CA")}</p>
      )}
    </div>
  );
}
